var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { pre: true, attrs: { class: "chi-simple-demos-wrapper" } },
      [
        _c("div", { pre: true, attrs: { class: "chi-simple-demos-header" } }, [
          _c("div", {
            pre: true,
            attrs: {
              "data-safe-id": "chi_chi_simple_demos_summary",
              "data-properties":
                "{\n      'classes': ['chi-simple-demos-summary'],\n      'style': {},\n      'hint': '',\n      'shared': true,\n      'value': 'No Patient Selected'\n    }",
              ":class": "components.chi_chi_simple_demos_summary.classes",
              ":style": "components.chi_chi_simple_demos_summary.style",
              ":title": "components.chi_chi_simple_demos_summary.hint",
              ":value": "components.chi_chi_simple_demos_summary.value",
              ":id": "'chi-simple-demos-summary'",
              autocomplete: "off",
              readonly: "",
              ref: "chi-simple-demos-summary",
              role: "readonlyfield",
              tabindex: "-1",
              "v-html": "components.chi_chi_simple_demos_summary.value"
            }
          })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }